const links = [
	{
		path: '/personnel-management/',
		home: true,
		name: 'Управление персоналом',
		active: true,
	},
];

export default links;
